import { createFileRoute, notFound } from '@tanstack/react-router';

import { loadCreditNoteMessages } from '@/modules/credit-note/public';
import { lazyScreen } from '@/shared/screen';

// /dev/credito (só dev): as telas reais da Operação de crédito sobre o MSW, sem login (X02). Em
// produção responde 404 e o chunk nem é pedido.
export const Route = createFileRoute('/dev/credito')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- notFound() é o contrato do TanStack Router.
    if (!import.meta.env.DEV) throw notFound();
  },
  loader: () => loadCreditNoteMessages(),
  component: import.meta.env.DEV ? lazyScreen(() => import('../-credito-shell'), 'CreditoShell') : () => null,
});
